import { Component, OnInit, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponents } from '../../../base.component';
import { ReferenceService } from 'src/app/services/reference.service';
import liff from '@line/liff';
@Component({
    selector: 'app-form-error',
    templateUrl: './form-error.component.html',
    styleUrls: ['./form-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormErrorComponent extends BaseComponents implements OnInit {
  log_session_text: string = "form-error";
  referenceUUID: string | null = null;
  content = signal<any>({
    header: "ระบบเกิดข้อผิดพลาด",
    body: ["ขออภัยในความไม่สะดวกเนื่องจากพบปัญหาในการเชื่อมต่อข้อมูล กรุณาทำรายการใหม่อีกครั้ง"]
  });
  linkMessage = signal<string>("กลับไปยังห้องสนทนา");
  constructor(
    protected injectorObj: Injector,
    private referenceService: ReferenceService
  ) {
    super(injectorObj)
  }
ngOnInit(): void {
  const funcName = 'ngOnInit';
  this.referenceUUID = this.referenceService.getReferenceUUID();
  this.log_session_text = `form-error referenceUUID:[${this.referenceUUID}]`;
  this.logger.info(`${this.log_session_text} ${funcName} start`);
}

closeLiff(){
  this.logger.info(`${this.log_session_text} close liff`);
  liff.closeWindow();
}
}
